import { RouteRecordRaw } from "vue-router"
import accountManagerProfiles from "@/router/companiesAndTerritories/accountManager"
import partnerMap from "@/router/companiesAndTerritories/partnerMap"
import partners from "@/router/companiesAndTerritories/partners"
import partnerParking from "@/router/companiesAndTerritories/partnerParking"
import pricingRules from "@/router/companiesAndTerritories/pricingRules"
import mobilityPackage from "@/router/companiesAndTerritories/mobilityPackage"
import transitPass from "@/router/companiesAndTerritories/transitPass"
import transitLines from "@/router/companiesAndTerritories/transitLines"
import geojsonGenerator from "@/router/companiesAndTerritories/geojsonGenerator"
import partnerMatchListing from "@/router/companiesAndTerritories/partnerMatchListing"
import saasParameters from "@/router/companiesAndTerritories/saasParameters"
import employees from "@/router/companiesAndTerritories/employees"

export const companiesAndTerritoriesRoutes: RouteRecordRaw[] = [
    ...accountManagerProfiles,
    ...partnerMap,
    ...partners,
    ...partnerParking,
    ...pricingRules,
    ...mobilityPackage,
    ...transitPass,
    ...transitLines,
    ...geojsonGenerator,
    ...partnerMatchListing,
    ...saasParameters,
    ...employees
]

export default companiesAndTerritoriesRoutes
